const HTTP_STATUS_CODE = {
  OK: 200,
  NO_CONTENT: 201,
  BAD_REQUEST: 400,
  EXPIRE_TOKEN: 401,
  UNAUTHORIZED: 403,
  NOT_FOUND: 444,
  NOT_ACCEPTABLE: 406,
  INTERNAL_SERVER_ERROR: 500,
};

export default HTTP_STATUS_CODE;
